/**
 * Styled Components - Created by jorge on 03/08/18.
 */
import styled from 'styled-components'

interface DivProps {
  secondary?: boolean
  fromModal?: boolean
  subTable?: boolean
}

export const Container = styled.div`
  display: flex;
  width: ${({ secondary, fromModal }: DivProps) => secondary ? '100%' : (fromModal ? '90%' : '38.75%')};
  max-width: ${({ secondary, subTable, fromModal }: DivProps) => 
    subTable ? (fromModal ? 'unset' : '654px') : (secondary ? '580px' : 'unset')};
  margin-bottom: ${({ secondary }: DivProps) => secondary ? '20px' : 'unset'};
  @media (max-width: 984px) {
    width: 100%;
    flex-wrap: ${({ subTable }: DivProps) => subTable ? 'wrap' : 'unset'}
    justify-content: ${({ subTable }: DivProps) => subTable ? 'center' : 'unset'}
  }
`

export const Tables = styled.div`
  width: 100%;
  z-index: 1;
  display: flex;
  align-items: ${({ secondary }: DivProps) => secondary ? 'flex-end' : 'flex-start'};
  @media (max-width: 984px) {
    flex-wrap: wrap;
    justify-content: center;
  }
`

export const TableDiv = styled.div`
  border-collapse: collapse;
  margin-bottom: 10px;
  margin-left: ${({ subTable }: DivProps) => subTable ? '45px' : 'unset'};
  margin-top: ${({ subTable }: DivProps) => subTable ? '40px' : '10px'};
  table-layout: fixed;
  width: 100%;
  z-index: 1;
  max-width: ${({ secondary }: DivProps) => secondary ? '310px' : 'unset'};
  ${({ subTable }: DivProps) => subTable ? `
    @media (max-width: 984px) {
      margin-left: 0px;
      margin-bottom: 20px;
    }
  ` : ''}
  @media (max-width: 665px) {
    margin-bottom: 0;
    margin-top: 25px;
    padding: 0;
    width: 100%;
  }
`

export const ImageContainer = styled.img`
  max-width: 238px;
  object-fit: contain;
  margin-left: 24px;
  @media (max-width: 698px) {
    max-width: 124px;
    margin-left: 0px;
  }
`

export const HeaderRow = styled.div`
  align-items: center;
  border-bottom: 1px solid #8c8c8c;
  display: flex;
  justify-content: space-between;
  padding-bottom: 4px;

  @media (max-width: 480px) {
    padding-left: ${({ secondary }: DivProps) => secondary ? '0px' : '7px'};
  }
`
export const HeaderCell = styled.div`
  text-align: left;
  width: 100%;
  margin-right: 8px;
  &:first-child {
    max-width: 70px;
  }
  &:last-child {
    text-align: center;
    max-width: 70px;
  }
`
export const Title = styled.div`
  color: #5f6062;
  font-size: 14px;
  font-weight: 600;
  letter-spacing: 0.1px;
  line-height: 23px;
  white-space: nowrap;
`
export const Row = styled.div`
  align-items: center;
  border-bottom: 1px solid #dcdcdc;
  display: flex;
  justify-content: space-between;
  padding-bottom: 8px;
  padding-top: 8px;

  @media (max-width: 480px) {
    height: 50px;
    padding-left: 5px;
  }
`

export const Subtitle = styled.div`
  font-size: 14px;
  margin-left: 10px;
  color: #b1b1b1;
  font-weight: normal;
`

export const Cell = styled.div`
  color: #5f6062;
  font-size: 14px;
  letter-spacing: 0.1px;
  line-height: 35px;
  width: 100%;
  margin-right: 8px;
  &:first-child {
    max-width: 70px;
  }
  &:last-child {
    text-align: center;
    max-width: 70px;
  }
  @media (max-width: 698px) {
    line-height: unset;
    font-size: ${({ secondary }: DivProps) => secondary ? '12px' : '14px'};
  }
`
export const TableTitle = styled.div`
  color: #5f6062;
  font-size: 16px;
  font-weight: 600;
  letter-spacing: 0.11px;
  line-height: 22px;
  margin-bottom: 20px;
  display: flex;
`



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/components/SizesTable/styledComponents.tsx